<template>
  <v-dialog v-model="dialog" scrollable persistent width="800px">
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <span class="text-center headline"> Seleccionar Programas </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row no-gutters>
            <v-col cols="12" sm="3">
              <v-combobox
                v-model="filtros.gestion"
                :items="gestiones"
                label="Gestion del programa"
                class="mr-1"
                :loading="loadinggestion"
                :disabled="loadingprograms"
                hide-details
                outlined
                dense></v-combobox>
            </v-col>
            <v-col cols="12" sm="9">
              <v-switch
                v-model="omit_filtro"
                label="Omitir el filtro por convenio"
                :disabled="loadingprograms"
                dense
                hide-details
                title="Omitir el filtro por convenio y mostrar todo."
                class="mb-4 mt-0"></v-switch>
            </v-col>
          </v-row>

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="programas"
            :single-select="singleSelect"
            :loading="loadingprograms"
            :search="search_progra"
            disable-pagination
            hide-default-footer
            item-text="text"
            item-key="id"
            show-select
            class="elevation-1">
            <template v-slot:top>
              <v-text-field
                outlined
                dense
                v-model="search_progra"
                label="Buscar en la lista"
                class="mx-4 mt-1"></v-text-field>
            </template>
          </v-data-table>
        </v-container>

        <p class="text-center red--text">{{ msg }}</p>
        <v-progress-linear indeterminate v-if="loading" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" rounded outlined @click="enviarSeleccionados()">
          <v-icon class="mx-1">mdi-content-save</v-icon> Aceptar
        </v-btn>
        <v-btn rounded outlined @click="cleartipo()"> <v-icon>mdi-close</v-icon> Cancelar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import gql from 'graphql-tag';
  import {getGestiones} from '@/views/consolidarfact/utils.ts'

  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        loading_sedes: false,
        loadinggestion: false,
        loadingprograms: false,
        omit_filtro: false,
        allsedes: [],
        sedes: [],
        gestiones: [2025, 2024,2023, 2022, 2021, 2020, 2019, 2018, 2017],
        programas: [],
        unidades: [],
        unidad: null,
        msg: '',
        singleSelect: false,
        selected: [],
        headers: [
          { text: 'Codigo', value: 'codigo' },
          { text: 'Programa', value: 'text' },
        ],
        filtros: {
          gestion: null,
          programa: null,
        },
        search_progra: '',
      };
    },
    computed: {},
    watch: {
      'filtros.gestion': function () {
        if (this.filtros.gestion) this.listarprogramasgraphql();
      },
      '$store.state.CARGO.sede': function () {
        this.listarprogramasgraphql();
      },
      '$store.state.convenio': function () {
        if (this.$store.state.convenio) {
          this.listarprogramasgraphql();
        }
      },
      omit_filtro: function () {
        this.listarprogramasgraphql();
      },
    },
    methods: {
      async openmodal() {
        this.dialog = true;
        this.selected = [];
        this.sedes = [];
        let date = new Date();
        let anio = date.getFullYear();
        this.search_progra = '';
        this.filtros.gestion = '' + anio;
        const g = await getGestiones(this);
        if(g){
          const gs = [];
          g.forEach(x=>{
            gs.push(x.gestion)
          })
          this.gestiones = gs.reverse();
        } 
        
      },
      cleartipo() {
        this.$emit('cleartipo');
        this.dialog = false;
      },
      async listarprogramasgraphql() {
        this.loadingprograms = true;
        this.loadingmodulos = true;
        this.programas = [];
        this.filtros.programa = null;
        let idsede = this.$store.state.CARGO.sede.id;
        const vue = this;
        var sql = gql`query{ getProgramas(cursor:1000000,estado:true,idsede:${idsede}, gestion:${this.filtros.gestion}){ id,fase,version,grupo,estado,fecha_inicio,fecha_fin,codigo,nombre_compuesto,universidad{id,nombre},postgrado{categoria{id}},plataforma_id} getPlataformas(estado: true) { id nombre direccion unidad_negocio_id estado } }`;
        await this.$apollo
          .query({ query: sql, variables: { cursor: this.cursor } })
          .then(({ data }) => {
            let datos = data.getProgramas;
            if (this.$store.state.convenio && !this.omit_filtro) {
              datos = datos.filter((x) => {
                let convenio = vue.$store.state.convenio.id;
                if (!x.universidad) x.universidad = { id: convenio };
                let universidad = x.universidad.id;
                return convenio == universidad;
              });
            }

            vue.plataformas = data.getPlataformas;
            let xprogras = [];
            datos.forEach((x, indice) => {
              x.text = `${indice + 1}.- ${x.nombre_compuesto}`;
              x.value = x.id;
              let iscurso = x.postgrado.categoria.id == 500; // curso id = 5
              if (!iscurso) xprogras.push(x);
            });
            if (vue.filtros.programa) {
              let existe = vue.programas.find((x) => x.id == vue.filtros.programa.id);
              if (!existe) xprogras.push(vue.filtros.programa);
            }
            vue.programas = xprogras;
            window.console.log(vue.programas);
            vue.loadingprograms = false;
            vue.loadingmodulos = false;
          })
          .catch(() => {
            vue.loadingprograms = false;
            vue.loadingmodulos = false;
          });
      },
      enviarSeleccionados() {
        this.$emit('programas_sel', this.selected);
        this.dialog = false;
      },
    },
  };
</script>
